//extracted by mini-css-extract-plugin
export default {"infoItemContainer":"InfoItem_infoItemContainer__T8w1W","infoItemIcon":"InfoItem_infoItemIcon__t59B4"};;